const intl = {
    // @ts-ignore
    'de': new Intl.DisplayNames(['de'], {type: 'language'}),
    // @ts-ignore
    'fr': new Intl.DisplayNames(['fr'], {type: 'language'}),
    // @ts-ignore
    'it': new Intl.DisplayNames(['it'], {type: 'language'})
}

export default function displayLanguage(language: string, displayLanguage: string): string {
    if (Object.keys(intl).includes(displayLanguage)) {
        // @ts-ignore
        return intl[displayLanguage].of(language);
    }

    return intl.de.of(language);
}